import React, { useState, useEffect } from "react";
import styles from "./LanguageCard.module.css";
import checkmarkIcon from "./Checkmark.svg";
import i18n from "i18next";
import Cookies from "js-cookie";
import mobile from "mobileBridge";
import { SettingLanguages } from "hooks/useSettings";
import i18next from "i18next";

export function LanguageCard() {
  //Check if there is already a saved Language option if not default to English
  const [selected, setSelected] = useState(() => {
    const storedSetting = localStorage.getItem("setting-language");
    if (storedSetting) {
      try {
        const setting = JSON.parse(storedSetting);
        return setting.language === SettingLanguages.Spanish
          ? "Español"
          : "English";
      } catch {
        return "English";
      }
    }
    return "English";
  });

  //Save the selected Language option and change the i18n language in index
  const setLanguage = async (selected) => {
    const newLanguage = selected === "Español" ? "es" : "en";

    const setting = {
      language:
        selected === "Español"
          ? SettingLanguages.Spanish
          : SettingLanguages.English,
    };
    localStorage.setItem("setting-language", JSON.stringify(setting));

    Cookies.set("language-code", newLanguage, {
      domain:
        window.location.hostname === "localhost" ? "localhost" : ".wwdb.com",
      path: "/",
    });

    i18next.changeLanguage(newLanguage);

    // Mirror the choice into the native app (no-op in a plain browser) so the
    // Flutter home page + native screens follow the user's language pick.
    mobile.postMessage("change-language", newLanguage);

    setSelected(selected);
  };

  return (
    <div className={styles.listGroup}>
      <div
        className={`${styles.listGroupItem} ${
          selected === "English" ? styles.selected : ""
        }`}
        onClick={() => setLanguage("English")}
      >
        <span>English</span>
        {selected === "English" && (
          <img
            src={checkmarkIcon}
            alt="Selected"
            className={styles.checkmark}
          />
        )}
      </div>
      <hr />
      <div
        className={`${styles.listGroupItem} ${
          selected === "Español" ? styles.selected : ""
        }`}
        onClick={() => setLanguage("Español")}
      >
        <span>Español</span>
        {selected === "Español" && (
          <img
            src={checkmarkIcon}
            alt="Selected"
            className={styles.checkmark}
          />
        )}
      </div>
    </div>
  );
}

export default LanguageCard;
